<template lang="pug">
  e-error(:error="error")
</template>

<script>
  export default {
    computed: {
      error () {
        return this.$store.getters.getError
      }
    }
  }
</script>
